export const PuntoEnvioMark = ({ className = "", size = "text-xl", light = true }) => (
  <span className={`inline-flex items-center gap-2 ${className}`} data-testid="puntoenvio-mark">
    <span className="inline-block h-[0.9em] w-[0.9em] rounded-full bg-[var(--lime)] pulse-dot" style={{ fontSize: "inherit" }} />
    <span className={`font-display-up ${size} tracking-tight ${light ? "text-white" : "text-[var(--ink)]"}`}>
      Punto<span className="text-[var(--lime)]" style={light ? {} : { color: "var(--forest)" }}>Envío</span>
    </span>
  </span>
);
